module.exports = __webpack_public_path__ + "media/wyposazenie/tapicerka-2900a7a9.png";